import { createContext, useContext, useState, useEffect } from 'react';
import { syncTokenWithServer } from './accountUtils';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    const name = localStorage.getItem('name');
    const pin = localStorage.getItem('pin');

    if (token && userId) {
      setUser({ id: userId, name, pin });
    }

    setLoading(false);
  }, []);

const login = async (token, userId, name, pin) => {
  localStorage.setItem('token', token);
  localStorage.setItem('userId', userId);
  localStorage.setItem('name', name);
  localStorage.setItem('pin', pin);

  //console.log('auth response:', token);

  setUser({ id: userId, name, pin });

  // ✅ Ensure token checks work immediately after login
  await syncTokenWithServer();
};

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    localStorage.removeItem('pin');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
